import { Container, Typography } from '@mui/material';

const BlogPostsPage = () => {
  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Blog Posts
      </Typography>
      <Typography>Coming soon...</Typography>
    </Container>
  );
};

export default BlogPostsPage;